// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

.ResourcrList_container__sl72i {
    height: 40rem;
}

.ResourcrList_row__BKX5O {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;
    box-shadow: none;
    background-color: #e1cff95e;
    height: 4rem;
}

.ResourcrList_subContainer__yLtEB {
    display: flex;
    justify-content: left;
    align-items: center;
}

.ResourcrList_image__LIRvB {
    margin: 0.4rem;
    height: 3rem;
    width: 3rem;
    border-radius: 0.5rem;
}

.ResourcrList_imageContainer__Lw55c {
    margin-left: 1rem; 
    margin-right: 3rem; 

}

.ResourcrList_textContainer__1tjYg {
    padding-left: 10;
    width: 15rem;
}

.ResourcrList_text1__Kvxp\\+ {
    font-weight: 600;
    font-size: 18px;
}

.ResourcrList_text2__uISfu {
    font-weight: 600;
    font-size: 14px;
}

.ResourcrList_buttonContainer__Ha55i {
    padding: 10px 5px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/Components/Resource/ResourcrList.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 29/3/2023\r\n */\r\n\r\n.container {\r\n    height: 40rem;\r\n}\r\n\r\n.row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin: 5px 0;\r\n    box-shadow: none;\r\n    background-color: #e1cff95e;\r\n    height: 4rem;\r\n}\r\n\r\n.subContainer {\r\n    display: flex;\r\n    justify-content: left;\r\n    align-items: center;\r\n}\r\n\r\n.image {\r\n    margin: 0.4rem;\r\n    height: 3rem;\r\n    width: 3rem;\r\n    border-radius: 0.5rem;\r\n}\r\n\r\n.imageContainer {\r\n    margin-left: 1rem; \r\n    margin-right: 3rem; \r\n\r\n}\r\n\r\n.textContainer {\r\n    padding-left: 10;\r\n    width: 15rem;\r\n}\r\n\r\n.text1 {\r\n    font-weight: 600;\r\n    font-size: 18px;\r\n}\r\n\r\n.text2 {\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n}\r\n\r\n.buttonContainer {\r\n    padding: 10px 5px 0 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ResourcrList_container__sl72i`,
	"row": `ResourcrList_row__BKX5O`,
	"subContainer": `ResourcrList_subContainer__yLtEB`,
	"image": `ResourcrList_image__LIRvB`,
	"imageContainer": `ResourcrList_imageContainer__Lw55c`,
	"textContainer": `ResourcrList_textContainer__1tjYg`,
	"text1": `ResourcrList_text1__Kvxp+`,
	"text2": `ResourcrList_text2__uISfu`,
	"buttonContainer": `ResourcrList_buttonContainer__Ha55i`
};
export default ___CSS_LOADER_EXPORT___;
